<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-cash</v-icon>
                <p style="color: white;">Sin Negociación</p>

            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="6">

                            <v-col cols="12" md="5">
                                <h4 style="color :#2196f3">Vamos a: </h4>
                                <v-radio-group :rules="rulesradios" v-model="datos.tipoNegociacion"
                                    style="margin: -1px; margin-left: 10px;">
                                    <v-radio label="Cada quien sus daños" value="3"></v-radio>
                                    <v-radio label="No se requiere negociación" value="4"></v-radio>
                                </v-radio-group>
                            </v-col>

                            <v-divider class="mt-1"></v-divider>

                            <div class="mt-2">
                                <span style="font-weight: bold;">Fecha de respuesta de la negociación:</span>
                                <v-dialog ref="dialog" outlined v-model="modal"
                                    :return-value.sync="datos.fecharespuesta" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="date-align-center">
                                            <v-text-field v-model="fechaResp" label="" readonly :rules="rulestextfechas"
                                                outlined dense v-bind="attrs" v-on="on"></v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="datos.fecharespuesta" locale="es-mx" :max="maxDate"
                                        :min="minDate" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="modal = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="$refs.dialog.save(datos.fecharespuesta)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </div>
                            <v-divider class="mt-1"></v-divider>

                            <div class="mt-2">
                                <span style="font-weight: bold;">Firma Electrónica Avanzada:</span>
                                <v-text-field solo
                                    v-on:blur="datos.firma = datos.firma != null ? datos.firma.trim() : null" dense
                                    hide-details style="-webkit-text-security: disc;" maxlength="17"
                                    v-model="datos.firma">
                                </v-text-field>
                                <div v-if="errorFirma">
                                    <span class='spanError' style="color:red;font-size:12px">{{ messageFirma }}</span>
                                    <br />
                                </div>
                            </div>


                            <v-divider class="mt-4"></v-divider>

                            <div class="mt-2">

                                <span style="font-weight: bold;">Observaciones</span>
                                <v-textarea @input="uppercase('observaciones')"
                                    v-on:blur="datos.observaciones = datos.observaciones != null ? datos.observaciones.trim() : null"
                                    :counter="$store.state.maxLengthComentarios"
                                    :maxlength="$store.state.maxLengthComentarios" :rules="rulestextarea" outlined
                                    rows="3" v-model="datos.observaciones"></v-textarea>
                            </div>


                        </v-col>
                    </v-row>


                    <v-col md="12">
                        <v-row justify="center">
                            <v-btn dark class="ma-2" color="primary" title="Guardar" @click="guardar()"
                                :disabled="disabledSave">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>
                            <v-btn dark class="ma-2" color="#FF4081" title="Cancelar" @click="cancelar()"
                                :disabled="disabledSave">
                                <span style='color: white;'>Cancelar</span>
                            </v-btn>
                        </v-row>
                    </v-col>


                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>




<script>
import Reporte from "@/services/ExpJur/ExpJur.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import moment from 'moment';
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
export default {
    title() {
        return this.$route.meta.title
    },
    data() {
        return {
            messageFirma: '',
            errorFirma: false,
            maxDate: '',
            minDate: '',
            fechaResp: '',
            modal: false,
            disabledSave: false,
            validForm: true,
            datos: {
                ngid: null,
                tipoNegociacion: null,
                fecharespuesta: null,
                firma: '',
                observaciones: null
            },
            rulesradios: [v => !!v || 'Seleccione una opción'],
            rulestextfechas: [v => !!v || 'Campo requerido'],
            rulestextarea: [//v => !!v || 'Campo requerido',
                v => {
                    if (v == null || v == '') {
                        return 'Campo requerido'
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                        }
                        else
                            return true
                    }
                },
            ],
            push: 0,
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
                d3id: 0
            },
        }
    },
    watch: {
        'datos.fecharespuesta'(val) {
            this.fechaResp = val;
        },
        'datos.firma'(val) {
            if (val == null || val == '') {
                this.errorFirma = true;
            }
            else {
                if (val.length < 8 || val.length > 16) {
                    this.errorFirma = true;
                }
                else
                    this.errorFirma = false;
            }
        }
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        async guardaDatos() {

            this.$swal({
                position: 'center',
                title: 'Guardando Negociación ...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });
            await Reporte.insertarNegociacionCierre(this).then(response => {
                setTimeout(() => {
                    this.$swal.close();
                    if (response) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se ha agregado con éxito la Negociación',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.cancelar();
                            }
                        });
                        setTimeout(() => {
                            this.$swal.close();
                            this.cancelar();
                        }, 3000);

                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'Hubo un error al guardar la negociación, Favor de avisar a Desarrollo',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                    }

                }, 2000);


            });



        },
        async guardar() {
            this.disabledSave = true;
            this.$refs.form.validate();
            let error = 0;
            if (this.datos.firma.length == 0) {
                this.messageFirma = 'Para dar respuesta a la Negociación es necesario ingresar su firma';
                this.errorFirma = true;
                error++;
            }
            if (this.datos.firma.length < 8 && this.datos.firma.length > 0) {
                this.messageFirma = 'Firma electrónica avanzada debe tener un mínimo de 8 y menor a 17 carácteres';
                this.errorFirma = true;
                error++;
            }


            if (this.$refs.form.validate() && error == 0) {
                await Reporte.valFirmaElectronica(this).then(response => {
                    if (response == 1) {
                        this.$swal({
                            position: 'center',
                            icon: 'info',
                            title: 'Firma electrónica incorrecta',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.disabledSave = false;

                    }
                    else {
                        this.guardaDatos();
                    }
                });
            }
            else {
                this.disabledSave = false;
            }




        },
        cancelar() {
            if (this.push == 0) {
                this.push++;
                this.$router.go(-1);
            }

        },
        uppercase(input) {
            if (input == 'observaciones') {
                if (this.datos.observaciones != '' && this.datos.observaciones != null) {
                    this.datos.observaciones = this.datos.observaciones.toUpperCase();
                }
            }

        },
    },
    async mounted() {
        let clavetercero = await MetodosGenerales.obtenerSessionReporte('reporte');
        if (clavetercero.d3id == undefined) {
            this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            return
        }

        this.changeReporteMenuOption(clavetercero.urlname);
        this.displayInputs = {
            nrreporte: clavetercero.nrreporte,
            svindice: clavetercero.svindice,
            d3id: clavetercero.d3id
        };

        await Reporte.obtenerEstatusListado(this).then(response => {
            if (this.validaConclusion
                || response.data[0].ConclusionDanosLes != 0
                || response.data[0].Estatus != 0
                || !response.data[0].permisoAltaNegociacion) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }

        });



        await Reporte.obtenerDatosNegociacion(this).then(response => {
            this.maxDate = response.data[0].today;
            this.datos.fecharespuesta = response.data[0].today;
            this.fechaResp = response.data[0].today;

            this.minDate = response.data[0].svfhreporte;

        });

    }
}
</script>

<style>
.date-align-center .v-input input {
    text-align: center !important;
}
</style>
<style scoped>
.type-label-style {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 12px;
}

.type-text-style {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 1.3em;
}
</style>